export const asset = (name) => `${process.env.PUBLIC_URL || ""}/member-assets/${name}`;
export const numberOrNull = (value) => {
  if (value === null || value === undefined || value === "" || typeof value === "boolean") return null;
  const result = Number(value);
  return Number.isFinite(result) && result >= 0 ? result : null;
};
export const formatMetric = (value) => value === null || value === undefined
  ? "—" : new Intl.NumberFormat("vi-VN", { maximumFractionDigits: 2 }).format(value);
export const safeImageUrl = (value) => typeof value === "string" && (/^https?:\/\//i.test(value) || /^\/(?!\/)/.test(value)) ? value : "";
const list = (value) => Array.isArray(value) ? value.filter((item) => item && typeof item === "object") : [];

export function normalizeMemberProfile(profile = {}) {
  const customer = profile.customer || {};
  const summary = profile.summary || {};
  const scores = list(profile.top_score_songs);
  const mockScores = scores.some((song) => String(song.song_id).startsWith("mock-score-"))
    || profile.data_status?.singing_score === "mock";
  const tierValue = String(customer.tier || "").trim().toLowerCase();
  const tier = ["silver", "gold", "platinum", "diamond"].includes(tierValue) ? tierValue : "member";
  return {
    customer, tier,
    visitsSource: profile.data_status?.visits_source || "",
    canSearchSongs: profile.capabilities?.song_search === true,
    editableFields: (Array.isArray(profile.editable_profile_fields) ? profile.editable_profile_fields : [])
      .filter((field) => ["name", "birth_date", "gender", "email", "address"].includes(field)),
    name: customer.name || "Khách hàng Muzic Box",
    avatar: safeImageUrl(customer.avatar_url),
    tierLabel: customer.tier_label || (tier === "member" ? "Chưa có thông tin hạng" : `Hạng ${tier[0].toUpperCase()}${tier.slice(1)}`),
    level: numberOrNull(customer.membership_level),
    points: numberOrNull(summary.loyalty_points ?? customer.points),
    hours: numberOrNull(summary.total_singing_hours),
    score: mockScores ? null : numberOrNull(summary.total_singing_score),
    // Legacy total_visits counts bookings at only the top five branches.
    visits: profile.data_status?.total_visits === "verified" ? numberOrNull(summary.total_visits) : null,
    scoreSongs: mockScores ? [] : scores,
    sungSongs: list(profile.top_sung_songs),
    branches: list(profile.top_branches),
    benefits: (Array.isArray(profile.benefits) ? profile.benefits : [])
      .map((item) => typeof item === "string" ? item : item?.description || item?.title)
      .filter((item) => typeof item === "string" && item.trim()),
    message: typeof profile.message === "string" ? profile.message : "",
  };
}
export const filterSongs = (songs, query) => {
  const normalize = (value) => String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D").toLowerCase();
  const search = normalize(query).trim();
  return songs.filter((song) => normalize(`${song.song_name} ${song.artist}`).includes(search));
};
